export const COUNTRIES_CHART_CALCULATE_TOP_OTHERS = 20;

const COUNTRIES_CHART_TOP_COUNT = COUNTRIES_CHART_CALCULATE_TOP_OTHERS;
const SPECIAL_MARKETS = ['total', 'global', 'global_wo_china'];
const OTHERS_MARKET = 'others';

const normalizeMarket = (market?: string): string => {
  if (typeof market !== 'string') {
    return '';
  }

  return market.toLowerCase();
};

export const isCountriesChartOthersMarket = (market?: string): boolean => {
  return normalizeMarket(market) === OTHERS_MARKET;
};

export const isCountriesChartSpecialMarket = (market?: string): boolean => {
  return SPECIAL_MARKETS.includes(normalizeMarket(market));
};

const getCountriesChartRequestMarkets = (markets?: string[]) => {
  if (!Array.isArray(markets)) {
    return markets;
  }

  return markets.filter((market) => {
    return !isCountriesChartOthersMarket(market);
  });
};

export const buildCountriesChartRequestParams = (params: any) => {
  const requestParams = {
    ...(params || {}),
    calculate_top_others: COUNTRIES_CHART_CALCULATE_TOP_OTHERS,
  };

  if (Array.isArray(requestParams.regions)) {
    requestParams.regions = getCountriesChartRequestMarkets(requestParams.regions);
  }
  if (Array.isArray(requestParams.country_trend_markets)) {
    requestParams.country_trend_markets = getCountriesChartRequestMarkets(
      requestParams.country_trend_markets,
    );
  }
  if (Array.isArray(requestParams.markets)) {
    requestParams.markets = getCountriesChartRequestMarkets(requestParams.markets);
  }

  return requestParams;
};

export const filterCountriesByMetric = (list: any[], metric: string): any[] => {
  if (!Array.isArray(list) || !metric) {
    return [];
  }

  return list.filter((item) =>
    item?.metrics?.some((metricItem: any) => metricItem?.metric === metric),
  );
};

export const buildCountriesChartDisplayList = (list?: any[]): any[] => {
  if (!Array.isArray(list)) {
    return [];
  }

  let othersItem: any = null;
  const countryList: any[] = [];
  list.forEach((item) => {
    const market = item?.market || item?.name;
    if (isCountriesChartOthersMarket(market)) {
      if (!othersItem) {
        othersItem = {
          ...item,
          market: OTHERS_MARKET,
        };
      }
      return;
    }

    if (isCountriesChartSpecialMarket(market)) {
      return;
    }

    countryList.push(item);
  });

  if (countryList.length <= COUNTRIES_CHART_TOP_COUNT) {
    return countryList;
  }

  if (!othersItem) {
    return countryList.slice(0, COUNTRIES_CHART_TOP_COUNT);
  }

  return [...countryList.slice(0, COUNTRIES_CHART_TOP_COUNT), othersItem];
};

export const buildCountriesTableDisplayList = (list?: any[]): any[] => {
  if (!Array.isArray(list)) {
    return [];
  }

  return list.filter((item) => {
    const market = item?.market || item?.name;
    return !isCountriesChartOthersMarket(market);
  });
};

export const getCountriesChartMarketList = (list?: any[]): string[] => {
  if (!Array.isArray(list)) {
    return [];
  }

  const markets: string[] = [];
  list.forEach((item) => {
    const market = item?.market;
    if (!market || isCountriesChartSpecialMarket(market)) {
      return;
    }

    markets.push(market);
  });

  return markets;
};

export const getCountriesChartRequestMarketList = (list?: any[]): string[] => {
  return getCountriesChartMarketList(list).filter((market) => {
    return !isCountriesChartOthersMarket(market);
  });
};
